import { Icon, Input, Radio, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_FEATURE_NAME_LENGTH, OCCASION } from '@hero/constants';

import * as S from './style';

function CreateAutomationForm({ formik }) {
  const { t } = useTranslation();

  return (
    <S.Form>
      <S.FormItem>
        <Typography variant="body2Bold" color="accent-secondary" emphasis="default">
          {t('selectAutomationType')}
        </Typography>
        <S.RadioInputWrapper>
          <Radio
            label={
              <S.RadioInputLabel>
                <Icon name="work-anniversary" /> {t('workAnniversary')}
              </S.RadioInputLabel>
            }
            name="type"
            value="work-anniversary"
            onChange={() => formik.setFieldValue('type', OCCASION.workAnniversary)}
          />
          <Radio
            label={
              <S.RadioInputLabel>
                <Icon name="birthday" /> {t('birthday')}
              </S.RadioInputLabel>
            }
            name="type"
            value="birthday"
            onChange={() => formik.setFieldValue('type', OCCASION.birthday)}
          />
        </S.RadioInputWrapper>
      </S.FormItem>
      <S.FormItem>
        <Typography
          as="div"
          variant="body2Bold"
          color="accent-secondary"
          emphasis="default"
          style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '-12px' }}
        >
          {t('whatWouldYouLikeToNameIt')}
          <Typography variant="caption1">{`(${t('helpsYouIdentifyItLater')})`}</Typography>
        </Typography>
      </S.FormItem>
      <S.FormItem>
        <Input
          name="name"
          variant="outlined"
          value={formik.values.name}
          label={`${t('automationName')}*`}
          onChange={formik.handleChange}
          inputProps={{
            maxLength: MAX_FEATURE_NAME_LENGTH
          }}
          helperText={`${formik.values.name.length}/${MAX_FEATURE_NAME_LENGTH} characters`}
        />
      </S.FormItem>
    </S.Form>
  );
}

export { CreateAutomationForm };
